/*eslint-disable */

import { bus } from '@/main';
import commonSocket from '@/commonSocket/index.js';
import moment from 'moment';

export default {
  name: 'self-user-status',
  components: {},
  props: ['userInfo'],
  data () {
    return {
      slefUserDDState:false,
      selfUserStatus:'',
    }
  },
  computed: {

  },
  mounted () {
    this.getSelfUserInfoMethod()
    bus.$on('selfUserUpdateStatus', (data) => {
      this.userInfo.is_online = data.is_online
    });
  },
  methods: {
    getSelfUserInfoMethod(){
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.selfUserStatus = res.data.data.current_status || 'Available'
      })
    },
    slefUserDropDownOpenMethod(){
      this.slefUserDDState = true
    },
    slefUserDropDownCloseMethod(){  
      this.slefUserDDState = false
    },
    selfUserStatusUpdatedMethod(value){
      this.selfUserStatus = value
      let data = new FormData();
      const payload = JSON.stringify({
        current_status:this.selfUserStatus,
        status_time:moment().format()
      })
      data.append('user', payload);
      this.$store.dispatch('updateProfileFun', data).then((res) => {
        const payload = {
          type: "self_user_stat",
          current_status:this.selfUserStatus,
          status_time:moment().format()
        };
        commonSocket.emit(payload);
      })
    }
  },
  watch:{
  }
}